const state = {
    httpURL: process.env.VUE_APP_ROOT_API,
    master:false,
    sessionToken: null,
    appTitle: process.env.VUE_APP_TITLE,
    masterApp: process.env.VUE_APP_masterApp,
    userName: 'Unknown user',
    userNameComplete: 'Unknown nameComplete',
    userCodigo: 'Unknown',
    userCorreo: null,
    // permisos: [],
    menu: [],
    apps: [],
    role: 'user',
    userId: '',
    version: '1.2',
    blockNotificaciones: false
}

const getters = {
    httpURL: state => {
        return state.httpURL;
    },
    master: state => {
        return state.master;
    },
    masterApp: state => {
        return state.masterApp;
    },
    sessionToken: state => {
        return state.sessionToken;
    },
    appTitle: state => {
        return state.appTitle;
    },
    userName: state => {
        return state.userName;
    },
    userNameComplete: state => {
        return state.userNameComplete;
    },
    userCodigo: state => {
        return state.userCodigo;
    },
    userCorreo: state => {
        return state.userCorreo;
    },
    // permisos: state => {
    //     return state.permisos;
    // },
    menu: state => {
        return state.menu;
    },
    apps: state => {
        return state.apps;
    },
    role: state => {
        return state.role;
    },
    userId: state => {
        return state.userId;
    },
    version: state => {
        return state.version;
    },
    blockNotificaciones: state => {
        return state.blockNotificaciones;
    }
}

const actions = {
    setSessionToken(context, payload) {
        context.commit('setSessionTokenHandler', payload);
    },
    setMaster(context, payload) {
        context.commit('setMasterHandler', payload);
    },
    setUserName(context, payload) {
        context.commit('setUserNameHandler', payload);
    },
    setUserNameComplete(context, payload) {
        context.commit('setUserNameCompleteHandler', payload);
    },
    setUserCodigo(context, payload) {
        context.commit('setUserCodigoHandler', payload);
    },
    setUserCorreo(context, payload) {
        context.commit('setUserCorreoHandler', payload);
    },
    // setPermisos(context, payload) {
    //     context.commit('setPermisosHandler', payload);
    // },
    setMenu(context, payload) {
        context.commit('setMenuHandler', payload);
    },
    setApps(context, payload) {
        context.commit('setAppsHandler', payload);
    },
    setRole(context, payload) {
        context.commit('setRoleHandler', payload);
    },
    setUserId(context, payload) {
        context.commit('setUserIdHandler', payload);
    },
    setVersion(context, payload) {
        context.commit('setVersionHandler', payload);
    },
    setBlockNotificaciones(context, payload) {
        context.commit('setBlockNotificacionesHandler', payload);
    }
}

// mutations
const mutations = {
    setSessionTokenHandler(state, token) {
        state.sessionToken = token;
    },
    setMasterHandler(state, master) {
        state.master = master;
    },
    setUserNameHandler(state, name) {
        state.userName = name;
    },
    setUserNameCompleteHandler(state, nameComplete) {
        state.userNameComplete = nameComplete;
    },
    setUserCodigoHandler(state, title) {
        state.userCodigo = title;
    },
    setUserCorreoHandler(state, userCorreo) {
        state.userCorreo = userCorreo;
    },
    // setPermisosHandler(state, permisos) {
    //     state.permisos = permisos;
    // },
    setMenuHandler(state, menu) {
        state.menu = menu;
    },
    setAppsHandler(state, apps) {
        state.apps = apps;
    },
    setRoleHandler(state, role) {
        state.role = role;
    },
    setUserIdHandler(state, userId) {
        state.userId = userId;
    },
    setVersionHandler(state, version) {
        state.version = version;
    },
    setBlockNotificacionesHandler(state, blockNotificaciones) {
        state.blockNotificaciones = blockNotificaciones;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}